import "react-datepicker/dist/react-datepicker.css";
import { CommonService } from "../../../../../../common/main/services/CommonService";
import CSSClassSerivce from "../../../../services/CommonCSSSerivce";
import { DatePickerControllerType1 } from "./DatePickerControllerType1";
import { IInputValidationItemProps, IInputValidatorItem } from "../../../../factorys/inputvalidation/interfaces/InputValidationInterfaces";
import { InputValidation } from "../../../../factorys/inputvalidation/InputValidation";
import InputValidationFactory from "../../../../factorys/inputvalidation/InputValidationFactory";
import { t } from "i18next";
import { EInputValidationResultType } from "../../../../factorys/inputvalidation/enums/InputValidationEnums";

export interface IDatePickerInputProps extends IInputValidationItemProps {
  disabled?: boolean;
  classNameRootFrame?: string;
  classNameFrame?: string;
  labelIsBold?: boolean;
  name?: string;
  timeStamp: number | undefined | null;

  // dateMin?: Date;
  // dateMax?: Date;

  readOnly?: boolean;
  classNameInput?: string;
  disabledAddClass?: string;
  defaultValue?: number | undefined;
  onInputChange?: ((it: number | undefined) => void) | null;

  onInputValidation?: ((it: EInputValidationResultType) => void) | null;
  validationItems?: IInputValidatorItem[] | null;
}

export const DatePickerInput1 = (props: IDatePickerInputProps) => {

  let classNameInput = (props.classNameInput)? CSSClassSerivce.datePickerInput: props.classNameInput;
  let classNameFrame = (props.classNameFrame)? CSSClassSerivce.datePickerFrame: props.classNameFrame;
  let labelIsBold = (props.labelIsBold)? false: props.labelIsBold;

  let dateIn = CommonService.getDateFromTimeStampInSeconds(props.timeStamp)
  const c = DatePickerControllerType1({ value: dateIn, disabled: props.disabled, classNameFrame: props.classNameFrame, classNameInput: props.classNameInput, disabledClass: props.disabledAddClass?props.disabledAddClass:"" })

  //let dateNow = new Date();
  let sDateMin = CommonService.getStringFromDateYYYYDDMM(new Date(0 * 1000)); //1970
  //let sDateMin = CommonService.getStringFromDateYYYYDDMM(new Date(631170000 * 1000)); //1990
  //let sDateMax = CommonService.getStringFromDateYYYYDDMM(props.dateMax?props.dateMax:new Date(dateNow.setMonth(dateNow.getMonth()+(12*10))))
  let sDateMax = CommonService.getStringFromDateYYYYDDMM(new Date(4102462800 * 1000)) //21000

  let value = !props.readOnly?CommonService.getStringFromDateYYYYDDMM(c.value):CommonService.getStringFromDateYYYYDDMM(dateIn)

  //init controllers
  const ivc = InputValidationFactory.getInputValidationController({
    validationItems: props.validationItems, 
    itemProps: props,
    itemController: c,
    onMount:()=>{ ivc?.validate({value:value?.toString(), ignoreBlur: false}) }
  });

  return (
    <div className={props.classNameRootFrame?props.classNameRootFrame:"w-full"}>
      <label htmlFor={props.name} className={CSSClassSerivce.labelClass+((labelIsBold)?" [&&]:font-bold":"") + " mr-2"}>
        {(props.name ? t(props.name) : "")}
      </label>
      <div 
        ref={(it) => c.setRefFrame(it)} >
        <div
          //id="datepicker_wrapper"
          className={classNameFrame}
          ref={(it) => c.setRefFrame(it)} >
          <input
            key={props.readOnly?value:null} //hint: new initial-value forces rerender of the component
            ref={(it) => { c.setRefInput(it) }}
            //pattern="\d{1,2}/\d{1,2}/\d{4}"
            type="date"
            name="date"
            //placeholder="sdf"
            //defaultValue={"1900-01-01"}
            className={classNameInput}
            defaultValue={value}
            //value={value}
            min={sDateMin}
            max={sDateMax}
            onBlur={(e) => {
              ivc?.strValidationIsVisible(e.target.value)
              c.setBlur(true)
            }}
            onChange={(it) => {
              if(props.readOnly) return;
              try {
                //console.log("strDate: " +  it.target.value)

                ivc?.validate({value: it.target.value});
                    
                let date = CommonService.getDateFromString(it.target.value)
                if(date == null) return;
                
                c.setValue(date)
                props.onInputChange!!(CommonService.mapDateToTimeStampInSeconds(date))
              } catch (e) {
                console.log(e?.toString())
              }
            }}
          />
        </div>
      </div>
      {(ivc != null) ? <InputValidation ivc={ivc} /> : <></>}
    </div>
  );

}

export default DatePickerInput1;